module.exports = __webpack_public_path__ + "media/images/banner-white-mode-042dae9057325879c2b5116ccc2db09e.webp";